// extracted by mini-css-extract-plugin
module.exports = {"button":"GlobalSearch_button__1PwoG","content":"GlobalSearch_content__28DSW"};